import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "container-search"
};
const _hoisted_3 = {
  class: "container-search-btn"
};
const _hoisted_4 = {
  class: "container-content"
};
const _hoisted_5 = {
  class: "container-content-table"
};
const _hoisted_6 = {
  key: 0,
  class: "state no"
};
const _hoisted_7 = {
  key: 1,
  class: "state yes"
};
const _hoisted_8 = {
  key: 2,
  class: "state ing"
};
const _hoisted_9 = {
  class: "container-content-pagination"
};
import { onMounted, reactive, ref } from 'vue';
import { Edit, Search } from '@element-plus/icons-vue';
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import apis from '@/api';
import dayjs from "dayjs";
import { USERINFO } from "@/store/mutation-types";
export default {
  __name: 'Index',
  setup(__props) {
    const router = useRouter();
    const elLoading = ref(false);
    const headerStyle = ref({
      background: '#FAFAFA'
    });
    const data = reactive({
      queryParam: {
        taskName: '',
        createTime: '',
        userName: ''
      },
      pagination: {
        totalSize: 0,
        pageSize: 10,
        pageNo: 1
      },
      tableData: [],
      userInfo: {},
      picAdminArea: ''
    });
    const handleSizeChange = val => {
      data.pagination.pageSize = val;
      loadData();
    };
    const handleCurrentChange = val => {
      data.pagination.pageNo = val;
      loadData();
    };
    const dateChange = e => {
      if (data.queryParam.createTime) {
        data.queryParam.createTime = dayjs(data.queryParam.createTime).format("YYYY-MM-DD HH:mm:ss");
        console.info(data.queryParam.createTime);
      }
    };
    const loadData = () => {
      elLoading.value = true;
      //访问后台接口获取数据
      const params = {
        ...data.queryParam,
        ...data.pagination,
        areaCode: data.picAdminArea
      };
      apis.queryAdvertPictureMonitorList(params).then(res => {
        if (res.success) {
          var _res$data;
          const {
            records,
            size,
            total,
            current
          } = (_res$data = res.data) !== null && _res$data !== void 0 ? _res$data : res.data = {};
          data.tableData = records !== null && records !== void 0 ? records : [];
          data.pagination = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error('err');
      }).finally(() => {
        elLoading.value = false;
      });
    };
    const handleView = row => {
      router.push({
        name: 'picture-monitor-detail',
        query: {
          id: row.id,
          picAdminArea: data.picAdminArea
        }
      });
    };
    const handleExport = row => {
      ElMessage.info('敬请期待');
    };
    const handleAdd = () => {
      router.push({
        name: 'picture-monitor-detail',
        query: {
          picAdminArea: data.picAdminArea
        }
      });
    };
    const queryUserRoles = () => {
      data.userInfo = JSON.parse(window.localStorage.getItem(USERINFO)) || {};
      const params = {
        userId: data.userInfo.userId,
        roleId: 'adv_pic_audit_'
      };
      apis.rolesByUserIdAndLikeRoleId(params).then(res => {
        if (res.success) {
          const roles = res.data;
          if (roles && roles.length > 0) {
            data.picAdminArea = roles[0].areaCode;
            // console.info(" monitor picAdminArea value:",data.picAdminArea)
            loadData();
          }
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error('err');
      }).finally(() => {});
    };
    onMounted(() => {
      queryUserRoles();
      // loadData()
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createVNode(_component_el_form, {
        inline: true
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "任务名称",
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: data.queryParam.taskName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.queryParam.taskName = $event),
            size: "small",
            placeholder: "请输入任务名称"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "创建人",
          prop: "userName"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: data.queryParam.userName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.queryParam.userName = $event),
            size: "small",
            placeholder: "请输入创建人"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "创建时间",
          prop: "createTime"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_date_picker, {
            size: "small",
            modelValue: data.queryParam.createTime,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.queryParam.createTime = $event),
            placeholder: "选择创建日期",
            onChange: dateChange
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
        type: "primary",
        icon: _unref(Search),
        plain: "",
        onClick: loadData
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("查询", -1)]))]),
        _: 1
      }, 8, ["icon"]), _createVNode(_component_el_button, {
        type: "primary",
        icon: _unref(Edit),
        onClick: handleAdd
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("新增", -1)]))]),
        _: 1
      }, 8, ["icon"])])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: data.tableData,
        style: {
          "width": "100%"
        },
        "header-cell-style": headerStyle.value
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "id",
          label: "序号",
          width: "180"
        }), _createVNode(_component_el_table_column, {
          prop: "taskName",
          label: "任务名称",
          width: "180"
        }), _createVNode(_component_el_table_column, {
          prop: "userName",
          label: "创建人"
        }), _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "创建时间"
        }), _createVNode(_component_el_table_column, {
          prop: "status",
          label: "状态"
        }, {
          default: _withCtx(scope => [scope.row.status == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[6] || (_cache[6] = [_createElementVNode("div", {
            class: "state-tag close"
          }, null, -1), _createTextVNode(" 未比对 ", -1)]))])) : _createCommentVNode("", true), scope.row.status == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[7] || (_cache[7] = [_createElementVNode("div", {
            class: "state-tag success"
          }, null, -1), _createTextVNode(" 已比对 ", -1)]))])) : _createCommentVNode("", true), scope.row.status == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[8] || (_cache[8] = [_createElementVNode("div", {
            class: "state-tag loading"
          }, null, -1), _createTextVNode(" 比对中 ", -1)]))])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "action",
          label: "操作"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handleView(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("查看", -1)]))]),
            _: 1
          }, 8, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "header-cell-style"])), [[_directive_loading, elLoading.value]])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        "page-sizes": [5, 10, 20, 30, 40],
        "page-size": data.pagination.pageSize,
        total: data.pagination.totalSize,
        currentPage: data.pagination.pageNo,
        "onUpdate:currentPage": _cache[3] || (_cache[3] = $event => data.pagination.pageNo = $event),
        layout: "prev, pager, next, sizes, jumper"
      }, null, 8, ["page-size", "total", "currentPage"])])])]);
    };
  }
};